module.exports = "pegasus/assets/hexagon-linkedin.gif";